
export class ColumnTransformerFloat {
    to(data: number): number {
      return data;
    }
    from(data: string): number {
      return Number.parseFloat(data);
    }
  }
